// extracted by mini-css-extract-plugin
export default {"notesImg":"BOMItemNotesButton__notesImg--PzbMM","selected":"BOMItemNotesButton__selected--QgM_U","add":"BOMItemNotesButton__add--gV4f9"};